import {
  SET_DISCOUNTED_CASH_FLOW_METHOD,
} from "./mutations";
import {store} from "../../index";
import DiscountedCashFlowMethod, {
  ONE_STAGE_METHOD,
  TerminalYear, THREE_STAGE_METHOD,
  TWO_STAGE_METHOD
} from "../../../models/valuation/DiscountedCashFlowMethod";
import {generateCapitalizationRate} from "../capitalizationRate/actions";
import {generateForecastedDOE} from "../valuation/actions";
import {generateForecastFreeCashFlow} from "../forecastFCF/actions";
import {generateCapitalizationOfEarnings} from "../capitalizationOfEarnings/actions";

export const generateDiscountedCashFlowMethod = (options = { clearCache: false }) => (dispatch) => {
  //dispatch(generateForecastedDOE())
  //dispatch(generateForecastFreeCashFlow())
  //dispatch(generateCapitalizationRate())  //these 3 dispatchs are done in generateCapitalizationOfEarnings()
  dispatch(generateCapitalizationOfEarnings())

  const {
    discountedCFM,
    capitalizationRate,
    forecastFCF,
    capitalizationOfEarnings,
    growthForecastStageDCF,
    taxes
  } = store.getState()

  const { forecastedDOE } = store.getState().valuation;

  const { discountedCashFlowMethod } = discountedCFM
  const  {afterTaxNetCashFlowDiscountRate } = capitalizationRate?.capitalizationRate?.afterTaxCapitalizationRate
  const { afterTaxFreeCashFlow } = forecastFCF?.forecastFreeCashFlow?.forecastedFreeCashFlowAfterTax
  const estimatedDiscretionaryOwnerEarnings = forecastedDOE?.forecastedDOE
  const divideCapitalizationRate = (
    capitalizationRate?.capitalizationRate.afterTaxCapitalizationRate.afterTaxNetCashFlowCapitalizationRate
    / 100
  )
  const { afterTaxCapitalizedEarningsOfSubjectCompany } = capitalizationOfEarnings.capitalizationOfEarnings
  const tax = Number(taxes.federalTax) + Number(taxes.stateTax)

  let growthPercentage = capitalizationRate?.capitalizationRate?.afterTaxCapitalizationRate?.riskFreeRate

  if (discountedCashFlowMethod && !options.clearCache) {
    if (discountedCashFlowMethod.method === TWO_STAGE_METHOD) {
      growthPercentage = growthForecastStageDCF?.growthForecastStageDCF?.analystChosenTwoStepGrowthRate
    }

    const EBIT = discountedCashFlowMethod.EBIT.map((value) => {
      if (value) return value
      return 0
    })
    const reinvestment = discountedCashFlowMethod.reinvestment.map((value) => {
      if (value) return value
      return 0
    })

    dispatch({
      type: SET_DISCOUNTED_CASH_FLOW_METHOD,
      payload: new DiscountedCashFlowMethod({
        ...discountedCashFlowMethod,
        afterTaxNetCashFlowDiscountRate,
        afterTaxFreeCashFlow,
        estimatedDiscretionaryOwnerEarnings,
        divideCapitalizationRate,
        growthPercentage,
        EBIT,
        tax,
        reinvestment,
        afterTaxCapitalizedEarningsOfSubjectCompany,
        terminalYear: new TerminalYear({
          ...discountedCashFlowMethod.terminalYear,
          longTermGrowthRate: capitalizationRate.capitalizationRate?.afterTaxCapitalizationRate?.riskFreeRate,
          divideCapitalizationRate,
        })
      })
    })

    return
  }

  dispatch({
    type: SET_DISCOUNTED_CASH_FLOW_METHOD,
    payload: new DiscountedCashFlowMethod({
      afterTaxNetCashFlowDiscountRate,
      afterTaxFreeCashFlow,
      estimatedDiscretionaryOwnerEarnings,
      afterTaxCapitalizedEarningsOfSubjectCompany,
      growthPercentage,
      terminalYear: new TerminalYear({
        longTermGrowthRate: capitalizationRate.capitalizationRate?.afterTaxCapitalizationRate?.riskFreeRate,
        divideCapitalizationRate
      })
    })
  })
}

export const updateDiscountCashFlowMethod = ({
  discountFactor,
  totalYears,
  method,
  terminalYear,
  EBIT,
  reinvestment,
  analystNote
}) => (dispatch) => {
  const {
    capitalizationRate,
    discountedCFM,
    growthForecastStageDCF
  } = store.getState()
  const discountedCashFlowMethod = { ...discountedCFM.discountedCashFlowMethod }

  if (discountFactor) discountedCashFlowMethod.discountFactor = discountFactor
  if (totalYears) {
    discountedCashFlowMethod.totalYears = totalYears
    discountedCashFlowMethod.EBIT = [...Array(totalYears).map(x => 0)]
    discountedCashFlowMethod.reinvestment = [...Array(totalYears).map(x => 0)]
  }
  if (method) {
    discountedCashFlowMethod.method = method
    if (method === TWO_STAGE_METHOD) {
      discountedCashFlowMethod.growthPercentage = (
        growthForecastStageDCF?.growthForecastStageDCF?.analystChosenTwoStepGrowthRate
      )
    } else {
      discountedCashFlowMethod.growthPercentage = (
        capitalizationRate?.capitalizationRate?.afterTaxCapitalizationRate?.riskFreeRate
      )
    }
  }
  if (terminalYear?.longTermGrowthRate) discountedCashFlowMethod.terminalYear.longTermGrowthRate = terminalYear.longTermGrowthRate
  if (EBIT) discountedCashFlowMethod.EBIT = EBIT
  if (reinvestment) discountedCashFlowMethod.reinvestment = reinvestment
  if (analystNote) discountedCashFlowMethod.analystNote = analystNote

  dispatch({
    type: SET_DISCOUNTED_CASH_FLOW_METHOD,
    payload: new DiscountedCashFlowMethod({
      ...discountedCashFlowMethod,
      terminalYear: new TerminalYear({
        ...discountedCashFlowMethod.terminalYear
      })
    })
  })
}